import React, { FunctionComponent } from 'react'
import { MobileItemList } from './mobile-item-list'
import { NavigationCta, NavigationItem } from '../types'
import { Button } from '../../../atoms/button'

interface MobileNavigationMenuProps {
  items: NavigationItem[]
  ctaButton: NavigationCta
}

const MobileNavigationMenu: FunctionComponent<MobileNavigationMenuProps> = ({ items, ctaButton }) => {
  return <MobileItemList items={items} ctaButton={ctaButton} />
}

export default MobileNavigationMenu
